<template>
<div>
  <!-- <div v-show="show" class="follow" @click="showPopup = true">
    <img src="@/assets/icons/focus.png" alt="">
  </div> -->
  <!-- 引导关注弹窗 -->
  <van-popup class="followPopup" v-model="showPopup" :close-on-click-overlay="false">
    <div class="follow-img">
      <img class="bg" src="@/assets/icons/follow.png" alt="">
      <div class="follow-content">
        <img class="qr" src="@/assets/icons/mmcb-qrcode.jpg" alt="">
        长按图片识别二维码
      </div>
    </div>
    <van-icon class="follow-close" name="close" color="#fff" size="40" @click="showPopup=false" />
  </van-popup>
</div>
</template>

<script>
// import { getProfile } from './query.gql'
export default {
  name: 'Follow',
  data() {
    return {
      // show: false,
      showPopup: true
    }
  }
}
</script>

<style lang="scss" scoped>
  .follow{
    img{
      width: 100%;
    }
  }
  .followPopup{
    background: none;
    width: 100%;
    text-align: center;
    .follow-img{
      position: relative;
      .bg{
        width: 100%;
      }
      .follow-content{
        color: #999;
        font-size: 13px;
        text-align: center;
        position: absolute;
        bottom: 8.5px;
        left: 0;
        right: 0;
        .qr{
          width: 100px;
          height: 100px;
          display: block;
          margin: 0 auto;
          padding-bottom: 7.5px;
        }
      }
    }
    .follow-close{
      padding-top: 20px;
    }
  }
</style>
